import { ComponentProps } from "react";
import { GARAGE_CONTRIBUTORS } from "@components/Newsletter/constants";
import Card from "@particles/card/Card";
import NewsletterArchiveArticlesList from "@routes/Newsletter/Archive/components/NewsletterArchiveArticlesList";
import NewsletterArchiveHeader from "@routes/Newsletter/Archive/components/NewsletterArchiveHeader";
import GarageSampleIssue from "@routes/Newsletter/Archive/Garage/SampleIssues/GarageSampleIssue";

type GarageArchivePageContentProps = {
  articles: ComponentProps<typeof Card>[];
};

const GarageArchivePageContent = ({
  articles,
}: GarageArchivePageContentProps): React.ReactElement => {
  return (
    <div className="grid grid-cols-4 gap-4">
      <div className="order-1 col-span-3 mb-6">
        <NewsletterArchiveHeader
          newsletterDescription="The hottest news on all things startup and tech to kickstart your week. [This newsletter is no longer in production.]"
          newsletterContributors={GARAGE_CONTRIBUTORS}
          newsletterTitle="Garage"
        />
      </div>

      <div className="order-3 col-span-1 mb-6 lg:order-2">
        <GarageSampleIssue />
      </div>

      <div className="order-2 col-span-4 lg:order-3">
        <NewsletterArchiveArticlesList
          keywordUrl={"/keywords/garage-newsletter"}
          articles={articles}
        />
      </div>
    </div>
  );
};

export default GarageArchivePageContent;
